export const inputStyleLight = `w-full p-4 font-light text-black transition ease-in-out bg-transparent border-2 border-gray-200 rounded-md focus:outline-theme-yellow`;

export const inputStyleDark = `w-full p-4 font-light text-black transition ease-in-out border-0 rounded-md bg-theme-dark-system-gray text-white `;
